export type DietSinceTimeUnit = 'year' | 'years' | 'month' | 'months';

export type DietSinceElapsed = {
  value: number;
  unit: DietSinceTimeUnit;
};

export function parseSinceDate(since: string | Date): Date {
  if (since instanceof Date) {
    return since;
  }

  const match = String(since).match(/^(\d{4})-(\d{2})(?:-(\d{2}))?/);
  if (match) {
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1;
    const day = match[3] ? parseInt(match[3], 10) : 1;
    return new Date(year, month, day);
  }

  return new Date(since);
}

export function getDietSinceElapsed(
  since: string | Date,
  referenceDate: Date = new Date(),
): DietSinceElapsed {
  const start = parseSinceDate(since);
  const end = referenceDate;

  if (isNaN(start.getTime()) || start > end) {
    return { value: 1, unit: 'month' };
  }

  let totalMonths =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth());

  if (end.getDate() < start.getDate()) {
    totalMonths--;
  }

  if (totalMonths < 0) {
    totalMonths = 0;
  }

  const years = Math.floor(totalMonths / 12);
  if (years >= 1) {
    return { value: years, unit: years === 1 ? 'year' : 'years' };
  }

  const months = Math.max(1, totalMonths);
  return { value: months, unit: months === 1 ? 'month' : 'months' };
}

export function getDateToday(): string {
    const date = new Date();
    
    return (
      date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, '0') + "-" +
      String(date.getDate()).padStart(2, '0') + " " +
      String(date.getHours()).padStart(2, '0') + ":" +
      String(date.getMinutes()).padStart(2, '0') + ":" +
      String(date.getSeconds()).padStart(2, '0')
    );
  }

export function  getDateTodayAddHour(): string{
    const date = new Date();
    const numOfHours = 12;
    date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);

    const dateStr =
      (date.getFullYear() + "-") +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) + " " +
      ("00" + date.getHours()).slice(-2) + ":" +
      ("00" + date.getMinutes()).slice(-2) + ":" +
      ("00" + date.getSeconds()).slice(-2);
    return dateStr;

  }
  